<template lang="pug">
  div.invoice-control.bill-of-waste-generator-bill-create.without-tabs
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
                name="address"
                inputType="address"
                :model="fields"
                tabView="tab1"
                :addressData="addressData"
                :treeAttributes="TREE_ATTRIBUTES"
              )

              e-form-group(
                name="account_number"
                label="Номер счета"
                :model="fields"
                tabView="tab1"
                validationRule="number"
              )

              e-form-group(
                name="date_opened"
                label="Дата открытия"
                inputType="calendar"
                :model="fields"
                tabView="tab1"
              )

              e-form-group(
                name="owner_id"
                label="Владелец счета"
                :model="fields"
                tabView="tab1"
              )

            div.col
              e-form-group(
                inputType="suggestion"
                label="Банк"
                name="bankName"
                realName="bank_id"
                validateAlias="bank_id"
                :model="fields"
                tabView="tab1"
                :minSuggestLen="2"
                :suggestionEndpoint="suggestionBankEndpoint"
                :transformSuggestions="transformBankSuggestions"
                @selectItem="selectBankItem"
                :useInnerSearch="false"
              )

              e-form-group(
                name="certificate_date"
                label="Дата справки"
                inputType="calendar"
                :model="fields"
                tabView="tab1"
              )

              e-form-group(
                name="certificate_number"
                label="Номер справки"
                :model="fields"
                tabView="tab1"
              )

              e-form-group(
                name="account_status"
                label="Статус счета"
                inputType="select"
                :model="fields"
                tabView="tab1"
                :options="statuses"
              )

              e-form-group(
                name="date_closed"
                label="Дата закрытия"
                inputType="calendar"
                :model="fields"
                tabView="tab1"
              )

              e-form-group(
                name="file"
                inputType="simple-file-uploader"
                label="Справка кредитной организации"
                :model="fields"
                tabView="tab2"
                :uploadUrl="uploadUrl"
                @fileUploaded="fileUploaded"
                @fileRemoved="fileRemoved"
                :showFilePreview="true"
                :required="false"
              )

</template>

<script>
  import {core} from "../../api/api-endpoints"
  import {billFormMixin} from "./mixins/bill-form-mixin";

  export default {
    mixins: [billFormMixin],
    methods: {
      getItemEndpoint () {
        return null
      },
      getUpdateOrCreateUrl () {
        return null
      },
      getDeleteUrl (id) {
        return null
      },
      getCollectionEndpoint() {
        return core.collection('billing_account_status')
      }
    }
  }
</script>
